import React from 'react';

import { AccessDeviceStatuses } from 'constants';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

export const AccessDeviceStatusSelect = ({
  label,
  variant = 'standard',
  field: { name = 'accountStatementStatuses', value },
  form: { errors, touched, setFieldValue = () => {} },
  omitFields = [],
  asyncErrors,
  margin = 'none',
  required = false,
  disabled = false,
  firstLoad = false,
  ...props
}) => {
  const filterOptions = generateFilterOptions('start', 'label');
  const statuses = AccessDeviceStatuses();

  return (
    <Autocomplete
      id={name}
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      required={required}
      disabled={disabled}
      firstLoad={firstLoad}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option?.label || ''}
      error={handleError(name, errors, touched, asyncErrors)}
      options={statuses.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) => option.value === value}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      value={statuses.find((status) => status?.value == value) || ''}
      {...props}
    />
  );
};
